<script lang="ts">
	import type { TabCaseItem } from '$lib_commons/models/TabCase.ts'

	interface Props {
		tabs?: TabCaseItem[]
		onPress?: (id: string) => void
	}

	let { tabs = [], onPress }: Props = $props()
</script>

<div class="tabs">
	{#each tabs as tab}
		<button class="item {tab.isActive ? 'active' : ''}" onclick={() => onPress?.(String(tab.id))}>
			{#if tab.icon}
				<tab.icon color={tab.isActive ? '#007ACC' : 'rgba(0, 44, 77, 0.50)'} />
			{/if}
			<span class="name">{tab.name}</span>
			{#if tab.count}
				<span class="count">{tab.count}</span>
			{/if}
		</button>
	{/each}
</div>

<style lang="postcss">
	.tabs {
		display: flex;
		align-items: center;
		gap: 2px;
		border-bottom: 1px solid #003a661a;
	}

	.tabs .item {
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		cursor: pointer;
		font-family: 'inter', sans-serif;
		padding: 0px 16px;
		border-bottom: 4px solid transparent;
	}

	.tabs .item .name {
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		text-align: center;
		color: rgba(0, 29, 51, 0.7);
		text-transform: capitalize;
	}

	.tabs .item .count {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		text-align: center;
		color: rgba(0, 29, 51, 0.7);
		min-width: 24px;
		height: 24px;
		background-color: rgba(0, 73, 128, 0.06);
		border-radius: 50%;
		padding: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tabs .item.active {
		border-bottom: 4px solid #007acc;
	}

	.tabs .item.active .name {
		color: #007acc;
		font-weight: 600;
	}
</style>
